import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const save: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M4.5,5 L4.5,17.5 L6.5,19.5 L19,19.5 L19.5,19 L19.5,5 L19,4.5 L5,4.5 Z M7.5,4.5 L7.5,11.5 L16.5,11.5 L16.5,4.5 M7.5,19.5 L7.5,14.5 L14.5,14.5 L14.5,19.5 M9.5,19.5 L10.5,19.5 L10.5,16 L9.5,16 Z"
      />
    </svg>
  );
};
